import React, { useEffect, useRef, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import FieldArea from "../../../../CustomComponents/FieldText";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../../../Firebase/config";
import sweetalreat from "sweetalert";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import EAddLanguage from "./EAddLanguage";
import * as yup from "yup";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const formdatatomap = [
  {
    title: (<>Are you open for part time job? <AsteriskLabel /></>),
    name: "part_time",
    placeholder: "part_time",
  },
  {
    title: "Price per hour in $",
    name: "price_per_hour",
    placeholder: "Enter Price per hour",
  },
  {
    title: "Price per month in $",
    name: "price_per_month",
    placeholder: "Enter Price per month",
  },
  {
    title:(<>Preferred working country <AsteriskLabel /></>),
    name: "working_country",
    placeholder: "working_country",
  },
  {
    title: "Preferred work location",
    name: "work_location",
    placeholder: "work_location",
  },
];

const EJobPreferences = ({ formData, setFormData, nextPage, previousPage }) => {
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(false);
  const [category, setCategory] = useState("");
  const [country, setCountry] = useState("");
  const [selectCatgory, setselectCatgory] = useState(formData?.category_index1);
  const [selectCountry, setSelectCountry] = useState(
    formData?.working_country_index,
  );
  const formikRef = useRef(null);

  const initialValues = {
    work_location: formData?.work_location || 1,
    part_time: formData?.part_time || 1,
    price_per_hour: formData?.price_per_hour,
    price_per_month: formData?.price_per_month,
    working_country: formData?.working_country,
  };

  const cvpreferences1 = yup.object().shape({
    part_time: yup.string().required("Part time job preference is required"),
    price_per_hour: yup
      .number()
      .typeError("Price per hour must be a number")
      .required("Price per hour is required"),
    price_per_month: yup
      .number()
      .typeError("Price per month must be a number")
      .required("Price per month is required"),
    working_country: yup
      .string()
      .required("Preferred working country is required"),
    work_location: yup.string().required("Preferred work location is required"),
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [image, setImage] = useState(null);

  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    setCategory(skillsss);
  }, [skillsss]);

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (formData.language?.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        ...values,
      }));
      nextPage();
    } else {
      setValidation(true);
    }
    setLoading(false);
  };

  const handleWorkingcountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setValues({
      ...formik.values,
      working_country_index: selectedOption,
      working_country: selectedOption.value,
    });
  };
  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  return (
    <div>
      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            04/06 <span>Job preferences</span>
          </h6>
          <h2>Please tell us about your work preferences</h2>
          <p>Share your work preferences with us</p>
        </div>
        <div className="col-lg-6   about-right add-cv">
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={formData?.part_time == 1 ? cvpreferences1 : ""}
            innerRef={formikRef}
            enableReinitialize
          >
            {(formik) => (
              <Form>
                {}
                <div>
                  {formdatatomap.map((prop, key) => {
                    if (prop.name == "working_country") {
                      if (
                        prop.name == "working_country" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <>
                            <div className="form-group">
                              <label>Preferred working country <AsteriskLabel /></label>
                              <ReactSelect
                                options={
                                  Array.isArray(country) &&
                                  country.map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                }
                                placeholder="Select country"
                                value={selectCountry}
                                onChange={(options) => {
                                  handleWorkingcountryChange(options, formik);
                                }}
                              />
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>
                          </>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "full_time_job") {
                      if (
                        prop.name == "full_time_job" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 1
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="1"
                                />
                                <span className="checkmark">Yes</span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 2
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="2"
                                />
                                <span className="checkmark">No</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location") {
                      if (
                        prop.name == "work_location" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 1
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="1"
                                />
                                <span className="checkmark">Virtual </span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 2
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="2"
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "part_time") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                checked={
                                  formik.values[prop.name] == 1 ? "checked" : ""
                                }
                                name={prop.name}
                                value="1"
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                checked={
                                  formik.values[prop.name] == 2 ? "checked" : ""
                                }
                                name={prop.name}
                                value="2"
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "price_per_hour") {
                      if (
                        prop.name == "price_per_hour" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "price_per_month") {
                      if (
                        prop.name == "price_per_month" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }

                    return (
                      <FieldInput
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  })}
                  <EAddLanguage
                    formData={formData}
                    setFormData={setFormData}
                    nextPage={nextPage}
                    previousPage={previousPage}
                  />
                  {validation == true && (
                    <p style={{ color: "red" }}>
                      At Least Add one Language with Proficiency
                    </p>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={handleNextClick} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default EJobPreferences;
